module.exports = __webpack_public_path__ + "media/images/lancaster_uni-e7f6398583f5bfaf3120043888543b57.svg";